export const categories = ['Mycie zewnętrzne', 'Wnętrze', 'Detailing', 'Pakiety'];

const STORAGE_KEY = 'mdclean_services';

// Pobierz dane z localStorage lub z pliku JSON przy pierwszym ładowaniu
const getInitialData = async () => {
  const localData = localStorage.getItem(STORAGE_KEY);
  if (localData) {
    return JSON.parse(localData);
  }
  
  // Jeśli nie ma danych w localStorage, załaduj z pliku
  try {
    const response = await fetch('/api/services.json');
    if (!response.ok) throw new Error('Nie udało się pobrać danych');
    const data = await response.json();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data.services));
    return data.services;
  } catch (error) {
    console.error('Błąd podczas pobierania usług:', error);
    return [];
  }
};

export const getServices = async () => {
  try {
    const data = await getInitialData();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Błąd podczas pobierania usług:', error);
    throw error;
  }
};

export const saveService = async (service) => {
  const services = await getServices();
  let updatedServices;
  
  if (service.id) {
    // Aktualizacja istniejącej usługi
    updatedServices = services.map(s => s.id === service.id ? service : s);
  } else {
    // Dodanie nowej usługi
    const newService = {
      ...service,
      id: Math.max(...services.map(s => s.id), 0) + 1
    };
    updatedServices = [...services, newService];
  }

  // Zapisz do localStorage
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedServices));
    return service.id ? service : updatedServices.find(s => s.id === service.id);
  } catch (error) {
    console.error('Błąd podczas zapisywania usługi:', error);
    throw error;
  }
};

export const deleteService = async (id) => {
  const services = (await getServices()).filter(s => s.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(services));
  return id;
};
